import { render } from "./secService.vue?vue&type=template&id=32511d98&scoped=true"
import script from "./secService.vue?vue&type=script&lang=js"
export * from "./secService.vue?vue&type=script&lang=js"

import "./secService.vue?vue&type=style&index=0&id=32511d98&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32511d98"]])

export default __exports__